import { TenantIncidentsScreen } from "@src/features/patriot-tools";

export default TenantIncidentsScreen;
